import { defineMessages } from 'react-intl';

export default defineMessages({
  goToHomePage: {
    id: 'ariaLabel.goToHomePage',
    defaultMessage: 'Go to home page',
  },
});
